import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import LanguageDetector from "i18next-browser-languagedetector";

 import translationenUS from "../../src/locale/enUS/translation.json";
 import translationbgBG from "../../src/locale/bgBG/translation.json";
 import translationzhCN from "../../src/locale/zhCN/translation.json";
 import translationzhHK from "../../src/locale/zhHK/translation.json";
 import translationdeDE from "../../src/locale/deDE/translation.json";
 import translationesES from "../../src/locale/esES/translation.json";
 import translationfrFR from "../../src/locale/frFR/translation.json";
 import translationjaJP from "../../src/locale/jaJP/translation.json";
 import translationkoKR from "../../src/locale/koKR/translation.json";
 import translationruRU from "../../src/locale/ruRU/translation.json";
 import translationcsCZ from "../../src/locale/csCZ/translation.json";

const fallbackLng = ["enUS"];
const availableLanguages = ["enUS", "bgBG", "zhCN", "zhHK", "deDE","esES", "frFR", "jaJP", "koKR","ruRU","csCZ"];

const resources = {
  enUS: {
    translation: translationenUS
  },
  bgBG: {
    translation: translationbgBG
  },
  zhCN: {
    translation: translationzhCN
  },
  zhHK: {
    translation: translationzhHK
  },
  deDE: {
    translation: translationdeDE
  },
  esES: {
    translation: translationesES
  },
  frFR: {
    translation: translationfrFR
  },
  jaJP: {
    translation: translationjaJP
  },
  koKR: {
    translation: translationkoKR
  },
  ruRU: {
    translation: translationruRU
  },
  csCZ: {
    translation: translationcsCZ
  }
};

// i18n
//   .use(Backend)
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources,
//     fallbackLng,

//     detection: {
//       checkWhitelist: true
//     },

//     debug: false,

//     whitelist: availableLanguages,

//     interpolation: {
//       escapeValue: false
//     }
//   });
i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      enUS: {
        translation: translationenUS
      },
      bgBG: {
        translation: translationbgBG
      },
      zhCN: {
        translation: translationzhCN
      },
      zhHK: {
        translation: translationzhHK
      },
      deDE: {
        translation: translationdeDE
      },
      esES: {
        translation: translationesES
      },
      frFR: {
        translation: translationfrFR
      },
      jaJP: {
        translation: translationjaJP
      },
      koKR: {
        translation: translationkoKR
      },
      ruRU: {
        translation: translationruRU
      },
      csCZ: {
        translation: translationcsCZ
      }
    }
  });

export default i18n;